import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { FetchResponseGetAccount, SubAccount } from './types.ts'

const uploadAgreement = async (formData: FormData) => {
  let fetchResponse = {
    data: {},
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.post(
      'api/dd_panel_sub_accounts/upload_agreement/',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const getSubAccountDetails = async () => {
  let fetchResponse: FetchResponseGetAccount = {
    data: {} as SubAccount,
    status: 200,
    error: null
  }

  try {
    const response = await httpClient.get<SubAccount>(
      '/api/dd_panel_sub_accounts/get_account/'
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }

  return fetchResponse
}

const getFakturowniaPanelLink = async () => {
  let fetchResponse = {
    data: {} as { link?: string; details?: string },
    status: 200,
    error: null
  }

  try {
    const response = await httpClient.get<{ link?: string, details?: string }>(
      '/api/dd_panel_sub_accounts/get_fakturownia_panel_link/'
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      console.log(error.response?.data)
      fetchResponse.error = error.response?.data.detail
      fetchResponse.status = error.response?.status as number
    }
  }

  return fetchResponse
}

export const ddPanelSubAccountsAPI = {
  getSubAccountDetails,
  uploadAgreement,
  getFakturowniaPanelLink
}
